export default __webpack_public_path__ + "static/testimonial-4-e706befb7c9103a1172fd74a4c2d3001.jpg";